import React from 'react';
import DataTable from 'material-table';
import PropTypes from 'prop-types';
import {makeStyles, Paper} from '@knockrentals/knock-shared-web';
import {Pagination} from '../../../../Features/common/Pagination';
import TableToolbar from './TableToolbar';
import {getTableColumns} from './getTableColumns';
import {DEFAULT_ROWS_PER_PAGE, ROWS_PER_PAGE_OPTIONS} from './constants';


const useStyles = makeStyles(() => ({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '70vh',
    overflow: 'hidden',
    '& .MuiTableRow-root': {
      height: '52px',
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px',
    },
    '& .MuiSwitch-root .Mui-checked': {
      padding: '6px',
      '& .MuiTouchRipple-root': {
        width: '36px',
        height: '36px',
      },
    },
    '& .MuiTableRow-footer': {
      borderTop: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTablePagination-root': {
      flexShrink: 0,
      position: 'sticky',
      bottom: 0,
      backgroundColor: '#fff',
      borderBottom: '0px',
      zIndex: 10,
      padding: '0px',
    },
  },
}));

const RenterAIDataTable = ({
  filteredProperties,
  filteredPropertyIds,
  handleBulkSettingsUpdate,
  handleFilterProperties,
  handleSettingsUpdate,
  isInternalMode,
  properties,
  selectedProduct,
  selectedProperties,
  setSelectedProperties,
}) => {
  const classes = useStyles();

  const columns = getTableColumns({
    filteredProperties,
    handleSettingsUpdate,
    isInternalMode,
    selectedProduct,
    selectedProperties,
    setSelectedProperties,
  });

  return (
      <DataTable
        columns={columns}
        components={{
          Container: (props) => <Paper className={classes.tableContainer} {...props} variant="outlined" />,
          Pagination: Pagination,
          Toolbar: () => (
            <TableToolbar
              filteredPropertyIds={filteredPropertyIds}
              handleBulkSettingsUpdate={handleBulkSettingsUpdate}
              handleFilterProperties={handleFilterProperties}
              properties={properties}
              selectedProperties={selectedProperties}
            />
          ),
        }}
        data={filteredProperties}
        options={
        {
          actionsColumnIndex: -1,
          emptyRowsWhenPaging: false,
          pageSize: DEFAULT_ROWS_PER_PAGE,
          pageSizeOptions: ROWS_PER_PAGE_OPTIONS,
          sorting: false,
        }}
      />
  );
};

RenterAIDataTable.propTypes = {
  filteredProperties: PropTypes.arrayOf(
    PropTypes.shape({
      aiEmailEnabled: PropTypes.string,
      emailProductEnabled: PropTypes.string,
      genAiEmailEnabled: PropTypes.string,
      leasingEnabled: PropTypes.bool,
      propertyId: PropTypes.number.isRequired,
      propertyName: PropTypes.string.isRequired,
      residentEnabled: PropTypes.bool,
      tableData: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  ),
  filteredPropertyIds: PropTypes.arrayOf(PropTypes.number),
  handleBulkSettingsUpdate: PropTypes.func.isRequired,
  handleFilterProperties: PropTypes.func.isRequired,
  handleSettingsUpdate: PropTypes.func.isRequired,
  isInternalMode: PropTypes.bool.isRequired,
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      aiEmailEnabled: PropTypes.string,
      emailProductEnabled: PropTypes.string,
      genAiEmailEnabled: PropTypes.string,
      leasingEnabled: PropTypes.bool,
      propertyId: PropTypes.number.isRequired,
      propertyName: PropTypes.string.isRequired,
      residentEnabled: PropTypes.bool,
      tableData: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  ),
  selectedProduct: PropTypes.string.isRequired,
  selectedProperties: PropTypes.arrayOf(PropTypes.number).isRequired,
  setSelectedProperties: PropTypes.func.isRequired,
};

export default RenterAIDataTable;
